import { Injectable } from "@angular/core";

import { ApiGatewayService } from "../api-gateway/api-gateway.service";

@Injectable()
export class HealthCheckService {
	constructor(private apiGatewayService: ApiGatewayService) { }

	public async checkGatewayStatus() {
		return await this.apiGatewayService.healthCheck();
	}
}
